/* ImaginLabs homepage — shared helpers. Safe to include from multiple sections. */
(function(){
  if (window.__ihHelpersLoaded) return;
  window.__ihHelpersLoaded = true;

  window.ihAddToCart = function(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    var productUrl = btn.getAttribute('data-product-url');
    if (!variantId) { window.location = productUrl; return; }
    var originalText = btn.textContent;
    btn.textContent = '…';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function(r){ return r.json(); })
    .then(function(data){
      if (data.status && data.status !== 200) { throw new Error(data.description); }
      btn.textContent = 'Added ✓';
      btn.classList.add('is-added');
      setTimeout(function(){
        btn.textContent = originalText;
        btn.classList.remove('is-added');
        btn.disabled = false;
      }, 2200);
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
        document.querySelectorAll('[data-cart-count], .cart-count-bubble span:first-child, .cart-icon-bubble span, .il-cart-badge')
          .forEach(function(el){ el.textContent = cart.item_count; });
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cartDrawer.open) { cartDrawer.open(btn); }
      });
    })
    .catch(function(err){
      console.warn('ihAddToCart error – redirecting to product page', err);
      window.location = productUrl;
    });
  };

  window.ihScroll = function(id, dir) {
    var el = document.getElementById(id);
    if (!el) return;
    var card = el.querySelector(':scope > *');
    var amount = card ? (card.offsetWidth + 16) * 2 : 300;
    el.scrollBy({ left: amount * dir, behavior: 'smooth' });
  };

  window.ihProgress = function(carId, barId) {
    var car = document.getElementById(carId);
    var bar = document.getElementById(barId);
    if (!car || !bar) return;
    var max = car.scrollWidth - car.clientWidth;
    var pct = max > 0 ? (car.scrollLeft / max) * 100 : 0;
    bar.style.width = Math.max(10, pct) + '%';
  };

  window.ihMiniSlide = function(wrapId, dir, opts) {
    opts = opts || {};
    var wrap = document.getElementById(wrapId);
    if (!wrap) return;
    var slides = wrap.querySelectorAll('.ih-slide');
    var dots = document.getElementById(wrapId + '-dots');
    if (!slides.length) return;
    var cur = 0;
    slides.forEach(function(sl, i){ if (sl.classList.contains('is-active')) cur = i; });
    var rawNext = cur + dir;
    if (opts.loop === false && (rawNext < 0 || rawNext >= slides.length)) return cur;
    var next = (rawNext + slides.length) % slides.length;
    wrap.setAttribute('data-ih-dir', dir > 0 ? 'next' : 'prev');
    slides[cur].classList.remove('is-active');
    slides[next].classList.add('is-active');
    if (dots) {
      dots.querySelectorAll('.ih-dot').forEach(function(d,i){ d.classList.toggle('is-active', i === next); });
    }
    if (opts.onChange) opts.onChange(next, slides.length);
    return next;
  };

  // Cross-section tab groups (used by New Arrivals ↔ Upcoming toggle)
  window.ihGroupTab = function(tabGroup, tabName) {
    var panels = document.querySelectorAll('[data-ih-tabgroup="' + tabGroup + '"]');
    if (!panels.length) return;
    panels.forEach(function(el){
      el.style.display = (el.getAttribute('data-ih-tabname') === tabName) ? '' : 'none';
    });
    document.querySelectorAll('[data-ih-tabbtn-group="' + tabGroup + '"]').forEach(function(btn){
      btn.classList.toggle('is-active', btn.getAttribute('data-ih-tabbtn') === tabName);
    });
    window.__ihActiveTab = window.__ihActiveTab || {};
    window.__ihActiveTab[tabGroup] = tabName;
  };

  // Re-apply the current tab state whenever Shopify's theme editor reloads a
  // section (e.g. while editing settings on New Arrivals or Upcoming), so the
  // two stay in sync instead of both appearing simultaneously.
  document.addEventListener('shopify:section:load', function(evt){
    var groups = evt.target.querySelectorAll('[data-ih-tabgroup]');
    groups.forEach(function(el){
      var g = el.getAttribute('data-ih-tabgroup');
      var active = (window.__ihActiveTab && window.__ihActiveTab[g])
        || document.querySelector('[data-ih-tabbtn-group="' + g + '"].is-active');
      var activeName = typeof active === 'string' ? active : (active && active.getAttribute('data-ih-tabbtn'));
      if (activeName) {
        window.ihGroupTab(g, activeName);
      }
    });
  });

  window.ihMiniGoto = function(wrapId, index) {
    var wrap = document.getElementById(wrapId);
    if (!wrap) return;
    var slides = wrap.querySelectorAll('.ih-slide');
    var dots = document.getElementById(wrapId + '-dots');
    if (!slides.length || index < 0 || index >= slides.length) return;
    slides.forEach(function(sl, i){ sl.classList.toggle('is-active', i === index); });
    if (dots) {
      dots.querySelectorAll('.ih-dot').forEach(function(d,i){ d.classList.toggle('is-active', i === index); });
    }
  };

  // auto-build dot indicators for any slideshow left with an empty -dots container
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('[id$="-dots"]').forEach(function(dotsWrap){
      if (dotsWrap.children.length) return;
      var wrapId = dotsWrap.id.replace(/-dots$/, '');
      var wrap = document.getElementById(wrapId);
      if (!wrap) return;
      var slides = wrap.querySelectorAll('.ih-slide');
      if (slides.length > 1) {
        slides.forEach(function(_, i){
          var d = document.createElement('span');
          d.className = 'ih-dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('role', 'button');
          d.setAttribute('tabindex', '0');
          d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          d.addEventListener('click', function(){ window.ihMiniGoto(wrapId, i); });
          dotsWrap.appendChild(d);
        });
      }
    });
  });
  // ── Shared, reusable scroll-carousel controller ──────────────────────────
  // Used by any section with a native overflow-x scroll row (New Arrivals,
  // Upcoming, etc.) so the pagination/arrow/autoplay/loop logic lives in ONE
  // place instead of being duplicated per section.
  //
  // opts: { gridId, prevSelector, nextSelector, dotsId, cardSelector,
  //         loop, autoplay, autoplaySpeed, pauseOnHover, slidesToMove, rootId }
  window.ihInitScrollCarousel = function (opts) {
    opts = opts || {};
    var grid = document.getElementById(opts.gridId);
    if (!grid) return;
    var root = opts.rootId ? document.getElementById(opts.rootId) : grid.closest('.ihp') || grid;
    if (root.__ihScrollCarouselFor === opts.gridId && root.__ihScrollCarouselInit) return; // already live
    root.__ihScrollCarouselInit = true;
    root.__ihScrollCarouselFor = opts.gridId;

    var cardSel = opts.cardSelector || ':scope > *';
    var loop = opts.loop !== false;
    var slidesToMove = opts.slidesToMove || 1;
    var prevBtn = opts.prevSelector ? document.querySelector(opts.prevSelector) : null;
    var nextBtn = opts.nextSelector ? document.querySelector(opts.nextSelector) : null;
    var pgWrap = opts.dotsId ? document.getElementById(opts.dotsId) : null;

    function cards() { return grid.querySelectorAll(cardSel); }
    function cardStep() {
      var c = cards()[0];
      if (!c) return 1;
      var style = getComputedStyle(grid);
      var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
      return c.getBoundingClientRect().width + gap;
    }
    function perView() { return Math.max(1, Math.round(grid.clientWidth / cardStep())); }
    function pageCount() { return Math.max(1, Math.ceil((cards().length - perView()) / slidesToMove) + 1); }
    function currentPage() {
      var step = cardStep() * slidesToMove;
      return step > 0 ? Math.round(grid.scrollLeft / step) : 0;
    }

    function buildDots() {
      if (!pgWrap) return;
      var pages = pageCount();
      pgWrap.innerHTML = '';
      if (pages <= 1) { pgWrap.style.display = 'none'; return; }
      pgWrap.style.display = '';
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ih-bs-pg-dot';
        b.setAttribute('aria-label', 'Go to position ' + (i + 1));
        (function (idx) { b.addEventListener('click', function () { goToPage(idx); restartAutoplay(); }); })(i);
        pgWrap.appendChild(b);
      }
      syncDots();
    }
    function syncDots() {
      if (!pgWrap) return;
      var idx = currentPage();
      pgWrap.querySelectorAll('.ih-bs-pg-dot').forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    function syncArrows() {
      var idx = currentPage(), pages = pageCount();
      if (prevBtn) prevBtn.classList.toggle('is-disabled', !loop && idx <= 0);
      if (nextBtn) nextBtn.classList.toggle('is-disabled', !loop && idx >= pages - 1);
    }
    function goToPage(idx) {
      var pages = pageCount();
      if (loop) idx = ((idx % pages) + pages) % pages;
      else idx = Math.max(0, Math.min(pages - 1, idx));
      grid.scrollTo({ left: idx * cardStep() * slidesToMove, behavior: 'smooth' });
    }
    function goPrev() { var idx = currentPage(); if (idx <= 0 && loop) { goToPage(pageCount() - 1); return; } goToPage(idx - 1); }
    function goNext() { var idx = currentPage(); if (idx >= pageCount() - 1 && loop) { goToPage(0); return; } goToPage(idx + 1); }

    if (prevBtn && !prevBtn.__ihBound) { prevBtn.__ihBound = true; prevBtn.addEventListener('click', function () { goPrev(); restartAutoplay(); }); }
    if (nextBtn && !nextBtn.__ihBound) { nextBtn.__ihBound = true; nextBtn.addEventListener('click', function () { goNext(); restartAutoplay(); }); }

    var scrollT;
    grid.addEventListener('scroll', function () {
      clearTimeout(scrollT);
      scrollT = setTimeout(function () { syncDots(); syncArrows(); }, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(root.__ihScrollResizeT);
      root.__ihScrollResizeT = setTimeout(function () { buildDots(); syncArrows(); }, 150);
    });

    var timer;
    function restartAutoplay() {
      clearInterval(timer);
      if (!opts.autoplay || pageCount() <= 1) return;
      timer = setInterval(goNext, opts.autoplaySpeed || 4000);
    }
    if (opts.pauseOnHover !== false) {
      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', restartAutoplay);
    }

    buildDots();
    syncArrows();
    restartAutoplay();
  };

})();